import { defineComponent as _defineComponent } from 'vue'
import {
  NavBar,
  HeadingDisplay,
  ButtonContainer,
  ButtonPrimary,
  ContentDisplay,
  LoaderIndicator,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';
import { BackButton } from '@/modules/common/components/buttons/BackButton';
import { useRoute, useRouter } from 'vue-router/composables';
import {
  getCustomerAccountStatus,
  DepositInformation
} from '@/modules/common/services/http/account';
import { computed, onMounted, ref } from 'vue';
import { CustomerModule } from '@/modules/common/store/CustomerModule';
import { TedSection, PixSection } from './components';
import { getPixInfo } from '../../services/cash';
import type { IPixInfo } from '../../services/cash';
import type { IDepositMethodSection } from './types';
import { headerTexts, helperViewTexts } from './texts';


export default /*#__PURE__*/_defineComponent({
  __name: 'Deposit',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const hasError = ref(false);
const isLoading = ref(true);
const depositInfo = ref<DepositInformation | IPixInfo | null>(null);

const customerId = computed(() => CustomerModule.getCustomerId);

const depositMethod = computed(() => route.meta!.depositMethod);

const staticTexts =
  depositMethod.value === 'ted' ? headerTexts.ted : headerTexts.pix;

const backButton = () => {
  router.back();
};

async function fetchDepositInfo() {
  try {
    hasError.value = false;
    isLoading.value = true;
    await fetchRequest();
  } catch (e) {
    hasError.value = true;
  } finally {
    isLoading.value = false;
  }
}

async function fetchRequest() {
  if (depositMethod.value === 'ted') {
    depositInfo.value = (
      await getCustomerAccountStatus(customerId.value)
    ).depositInformation;
  } else {
    depositInfo.value = await getPixInfo();
  }
}

function getDepositMethodSection(): IDepositMethodSection {
  if (depositMethod.value === 'ted')
    return {
      component: TedSection,
      prop: 'deposit-information',
      value: depositInfo.value as DepositInformation
    };
  return {
    component: PixSection,
    prop: 'pix-info',
    value: depositInfo.value as IPixInfo
  };
}

onMounted(async () => {
  await fetchDepositInfo();
});

return { __sfc: true,route, router, hasError, isLoading, depositInfo, customerId, depositMethod, staticTexts, backButton, fetchDepositInfo, fetchRequest, getDepositMethodSection, NavBar, HeadingDisplay, ButtonContainer, ButtonPrimary, ContentDisplay, LoaderIndicator, HelperViewStatus, BackButton, helperViewTexts }
}

})